import type { KpiSummary } from '../../lib/kpi';
import { formatKpi, KPI_CATALOG } from './kpiCatalog';

type Props = {
  summary: KpiSummary;
};

const CELL = 'whitespace-nowrap px-3 py-2 text-right';

/** A row per operator, a column per granted KPI, the sum at the foot — the
 *  same figures as the cards above, split out. */
export function OperatorTable({ summary }: Props) {
  if (summary.operators.length === 0) return null;

  return (
    <section
      aria-label="By operator"
      className="overflow-x-auto rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)]"
    >
      <table className="w-full text-sm">
        <thead className="border-b border-[var(--co-border)] text-xs text-[var(--co-muted)]">
          <tr>
            <th scope="col" className="px-3 py-2 text-left font-medium">
              Operator
            </th>
            {summary.kpis.map((key) => (
              <th key={key} scope="col" className={`${CELL} font-medium`}>
                {KPI_CATALOG[key].label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {summary.operators.map((operator) => (
            <tr key={operator.id} className="border-b border-[var(--co-border)] last:border-b-0">
              <th scope="row" className="px-3 py-2 text-left font-medium">
                {operator.name}
              </th>
              {summary.kpis.map((key) => (
                <td key={key} className={CELL}>
                  {formatKpi(key, operator.figures, summary.currency)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {summary.operators.length > 1 && (
          <tfoot className="border-t border-[var(--co-border)] font-semibold">
            <tr>
              <th scope="row" className="px-3 py-2 text-left">
                Total
              </th>
              {summary.kpis.map((key) => (
                <td key={key} className={CELL}>
                  {formatKpi(key, summary.totals, summary.currency)}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </section>
  );
}
